import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486b6c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "关于我们", -1))
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "row head-content" }
const _hoisted_4 = { class: "col-3 head-logo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "statics/ll/img/logo.png" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, null, -1))
const _hoisted_8 = {
  class: "col-2",
  style: {"background":"white"}
}
const _hoisted_9 = { class: "row head-language" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:;",
    id: "flip"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: "statics/ll/img/menu.png" })
  ])
], -1))
const _hoisted_11 = { class: "wrapper-x" }
const _hoisted_12 = { class: "wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "statics/ll/img/xt.jpg",
    style: {"margin-top":"6px"}
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "statics/ll/img/xt.jpg",
    style: {"margin-top":"6px"}
  })
], -1))
const _hoisted_15 = { class: "head-nav" }
const _hoisted_16 = {
  class: "menumob",
  id: "panel"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menumob-yd" }, null, -1))
const _hoisted_23 = {
  class: "row head-language2",
  style: {"justify-content":"center"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","padding-left":"0.5rem","align-items":"center","padding-right":"0.5rem"} }, [
  /*#__PURE__*/_createElementVNode("img", { src: "statics/ll/img/xt.jpg" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goLink(1)))
          }, _hoisted_6)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputValue) = $event)),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.change()), ["enter"]))
                }, null, 544), [
                  [_vModelText, $setup.inputValue]
                ])
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: _normalizeClass($setup.show == false ? 'head-language-a2' : 'head-language-a1'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeLanuange(1)))
              }, "EN", 2)
            ]),
            _hoisted_14,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: _normalizeClass($setup.show == false ? 'head-language-a1' : 'head-language-a2'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeLanuange(2)))
              }, "CN", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "head-nav-a",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goLink(1)))
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "Home" : "首页"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.goLink(2))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "AboutUs" : "关于我们"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow1 ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.goLink(3))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "Research and Innovation" : "研究与创新"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow2 ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.goLink(4))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "Latest Research" : "科技前沿"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow3 ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.goLink(5))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "International Cooperation" : "国际合作"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow4 ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.goLink(6))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "News" : "新闻"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow5 ? 'display:block' : '')
              }, null, 4)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.goLink(7))),
              class: "head-nav-a"
            }, [
              _createTextVNode(_toDisplayString($setup.show ? "Expert Committee" : "专家委员会"), 1),
              _createElementVNode("span", {
                class: "head-nav-span",
                style: _normalizeStyle($setup.checkShow6 ? 'display:block' : '')
              }, null, 4)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_17,
          _createElementVNode("a", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.goLink(1))),
            class: "head-nav-mo-a",
            style: {"color":"#eb004b"}
          }, "首页")
        ]),
        _createElementVNode("li", null, [
          _hoisted_18,
          _createElementVNode("a", {
            class: "head-nav-mo-a",
            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.goLink(2)))
          }, "关于我们")
        ]),
        _createElementVNode("li", null, [
          _hoisted_19,
          _createElementVNode("a", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.goLink(3))),
            class: "head-nav-mo-a"
          }, "研究与创新")
        ]),
        _createElementVNode("li", null, [
          _hoisted_20,
          _createElementVNode("a", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.goLink(4))),
            class: "head-nav-mo-a"
          }, "科技前沿")
        ]),
        _createElementVNode("li", null, [
          _hoisted_21,
          _createElementVNode("a", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.goLink(5))),
            class: "head-nav-mo-a"
          }, "国际合作")
        ]),
        _createElementVNode("li", null, [
          _hoisted_22,
          _createElementVNode("a", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.goLink(6))),
            class: "head-nav-mo-a"
          }, "新闻")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: _normalizeClass($setup.show == false ? 'head-language-a2' : 'head-language-a1'),
                onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.changeLanuange(1)))
              }, "EN", 2)
            ]),
            _hoisted_24,
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: _normalizeClass($setup.show == false ? 'head-language-a1' : 'head-language-a2'),
                onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.changeLanuange(2)))
              }, "CN", 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}